import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { TimeToPrice } from '~/Api/Analytics/VirtualBrand/TimeToPrice';
import { formatHumanDate } from '~/DateTime';
import { selectDataSourcesByCountry, State as DataSourceState } from '~/MedicinalBrandsAnalytics/DataSource';
import {
	RegionAvailability,
	selectRegionAvailabilities,
	State as RegionState,
} from '~/MedicinalBrandsAnalytics/Region';
import {
	loadEuropeTimeToPrice,
	selectTimeToPriceById,
	State as TimeToPriceState,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/TimeToPrice';

import TimeToPriceTab from './TimeToPriceTab';

interface State {
	medicinalBrandsAnalyticsRegion: RegionState;
	medicinalBrandsAnalyticsDataSource: DataSourceState;
	medicinalBrandsAnalyticsTimeToPrice: TimeToPriceState;
}

interface OwnProps {
	virtualBrand: VirtualBrand;
}

const memoizedSelectDefaultRegionAvailability = memoizeOne(
	(regionState: RegionState, dataSourceState: DataSourceState): RegionAvailability | null => {
		const availabilities = selectRegionAvailabilities(
			regionState,
			selectDataSourcesByCountry(dataSourceState.dataSources || [])
		);
		const europe = availabilities?.find((regionAvailability) => regionAvailability.region.id === 'europe');
		return europe?.subRegions.find((regionAvailability) => regionAvailability.region.id === 'eu-eaa') || null;
	}
);

function mapStateToProps(
	{ medicinalBrandsAnalyticsRegion, medicinalBrandsAnalyticsDataSource, medicinalBrandsAnalyticsTimeToPrice }: State,
	{ virtualBrand }: OwnProps
): {
	isFetching: boolean;
	marketingAuthorisationDate: string | null;
	prices: TimeToPrice[] | null;
	defaultRegionAvailability: RegionAvailability | null;
} {
	const timeToPriceState = selectTimeToPriceById(medicinalBrandsAnalyticsTimeToPrice, virtualBrand.id);

	return {
		isFetching: timeToPriceState?.isFething || false,
		prices: timeToPriceState?.prices || null,
		marketingAuthorisationDate:
			timeToPriceState && timeToPriceState.epar && timeToPriceState.epar.marketingAuthorisationDate
				? formatHumanDate(timeToPriceState.epar.marketingAuthorisationDate)
				: null,
		defaultRegionAvailability: memoizedSelectDefaultRegionAvailability(
			medicinalBrandsAnalyticsRegion,
			medicinalBrandsAnalyticsDataSource
		),
	};
}

const actions = {
	onLoad: loadEuropeTimeToPrice,
};

export default connect(mapStateToProps, actions)(TimeToPriceTab);
